import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import { AppButton } from '../../components/app-button'
import styles from './article-apps.module.scss'

/**
 * Displays AppStore and GooglePlay buttons.
 */
export const ArticleApps: FunctionComponent = () => (
    <div className={classNames(styles.section, styles.apps)}>
        {(['GooglePlay', 'AppStore'] as const).map((type) => (
            <div key={type} className={styles.app}>
                <AppButton type={type} />
            </div>
        ))}
    </div>
)
